import { render, staticRenderFns } from "./GestionParametrosConfiguracion.vue?vue&type=template&id=4894fb87&"
import script from "./GestionParametrosConfiguracion.vue?vue&type=script&lang=js&"
export * from "./GestionParametrosConfiguracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
